import AdminDashBoard from './adminDashBoard'
export default AdminDashBoard
